import request from "../request"
//提交留言板内容
export function addMessageBoard(data) {
    return request({
      url: '/messageBoard/',
      method:'post',
      data:data
    })
 }


// WEBPACK FOOTER //
// ./src/api/messageBoard.js